<script lang="ts">
	import * as Card from '$lib/components/ui/card/index.js';
	import { cn } from '$lib/utils.js';
	import { localizeHref } from '@/paraglide/runtime';
	import type { UsersResponse } from '@/pocketbase/pocketbase-types';
	import { pb } from '@/utils/ApiClient';
	import Award from '@lucide/svelte/icons/award';
	import Star from '@lucide/svelte/icons/star';

	interface Props {
		owner: UsersResponse;
		reviewCount: number;
		class?: string;
	}

	let { owner, reviewCount, class: className }: Props = $props();

	const displayName = $derived(owner.name || owner.username || 'Armador');
	const profileHref = $derived(owner.username ? localizeHref(`/perfil/${owner.username}`) : null);
</script>

<Card.Root class={cn('relative mb-6 max-md:mt-6', className)}>
	<Card.Content class="flex items-center gap-4 px-4">
		{#if profileHref}
			<a href={profileHref} class="shrink-0">
				<img
					class="inline-block h-16 w-16 rounded-full object-cover outline-1 -outline-offset-1 outline-black/5"
					src={pb.files.getURL(owner, owner.avatar, { thumb: '128x128' })}
					alt="Foto de perfil de {displayName}"
					width="64"
					height="64"
				/>
			</a>
		{:else}
			<img
				class="inline-block h-16 w-16 shrink-0 rounded-full object-cover outline-1 -outline-offset-1 outline-black/5"
				src={pb.files.getURL(owner, owner.avatar, { thumb: '128x128' })}
				alt="Foto de perfil de {displayName}"
				width="64"
				height="64"
			/>
		{/if}
		<div class="min-w-0">
			{#if profileHref}
				<a href={profileHref} class="text-lg font-bold text-gray-900 hover:text-gray-700">
					{displayName}
				</a>
			{:else}
				<h3 class="text-lg font-bold text-gray-900">{displayName}</h3>
			{/if}
			<div class="mt-1 flex flex-col gap-1 md:flex-row md:items-center md:gap-1.5">
				<div class="flex items-center text-sm text-gray-500">
					<Award class="mr-1 h-4 w-4 shrink-0 text-amber-500" />
					<span>Armador experimentado</span>
				</div>
				{#if reviewCount > 0}
					<span class="hidden text-gray-400 md:inline" aria-hidden="true">·</span>
					<div class="flex items-center gap-1.5 text-sm text-gray-500">
						<Star class="h-3.5 w-3.5 shrink-0 fill-amber-400 text-amber-400" aria-hidden="true" />
						<span class="tabular-nums">
							{reviewCount}
							{reviewCount === 1 ? 'reseña' : 'reseñas'}
						</span>
					</div>
				{/if}
			</div>
		</div>
	</Card.Content>
</Card.Root>
